var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoorOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M560 448.001H512V113.508C512 86.259 490.5 64.009 464 64.009H352V128.008H448V512H560C568.875 512 576 504.875 576 496V464.001C576 455.126 568.875 448.001 560 448.001ZM280.25 1.011L88.25 50.759C73.999 54.509 64 67.759 64 82.884V448.001H16C7.125 448.001 0 455.126 0 464.001V496C0 504.875 7.125 512 16 512H320V33.135C320 11.635 300.5 -4.239 280.25 1.011ZM232 288.005C218.75 288.005 208 273.63 208 256.005S218.75 224.006 232 224.006S256 238.381 256 256.005S245.25 288.005 232 288.005Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorOpen);
export default __webpack_public_path__ + "static/media/door-open.aa96465babd252f0b28398fbd487514e.svg";
export { ForwardRef as ReactComponent };